// DS: i9.16
import React from 'react';
import IconWrap from '../../IconWrap';
const Discord = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F7616D",
        fillRule: "evenodd",
        d: "M8 1.25a2.4 2.4 0 0 0-1.705.709h-.001l-.496.497a.73.73 0 0 1-.513.211h-.712a2.406 2.406 0 0 0-2.406 2.406v.712a.73.73 0 0 1-.212.514l-.496.495a2.406 2.406 0 0 0 0 3.411v.001l.497.496a.73.73 0 0 1 .211.513v.712a2.406 2.406 0 0 0 2.406 2.406h.712c.192 0 .377.077.514.212l.495.495v.002a2.406 2.406 0 0 0 3.411 0l.001-.002.496-.496a.73.73 0 0 1 .513-.211h.712a2.406 2.406 0 0 0 2.406-2.406v-.712c0-.192.077-.377.212-.514l.495-.495h.002a2.406 2.406 0 0 0 0-3.411l-.002-.001-.496-.496a.73.73 0 0 1-.211-.513v-.712a2.406 2.406 0 0 0-2.406-2.406h-.712a.73.73 0 0 1-.514-.212l-.495-.496A2.4 2.4 0 0 0 8 1.25",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#06070D",
        d: "M11.315 5.184a.8.8 0 0 1 0 1.13l-5.5 5.5a.8.8 0 0 1-1.131-1.13l5.5-5.5a.8.8 0 0 1 1.13 0M5.75 7.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.5 10.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
    })));
};
Discord.displayName = 'Discord';
export default Discord;

//# sourceMappingURL=Discount.js.map